// Importing React...
import React from 'react';
import logo from '../images/logo.jpg';
import styles from './boxabl_logo.module.scss';
// Boxabl Logo
const Logo = () => <img src={logo} className={styles.logo} />;

export default Logo;
